import React from 'react';

import styles from './SearchProductList.module.css'
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {Product} from "../../../../widgets/ProductCard/types/productCard.interface.ts";
import {useScreenDetector} from "../../../../hooks/useScreenDetector.ts";
import Lightbox from "yet-another-react-lightbox";

interface Props {
    products: Product[],
    productsLength: number,
}

interface PropsProductRow {
    product: Product,
    template: string,
}

const ProductRow: React.FC<PropsProductRow> = ({product, template}) => {
    const [openImg, setOpenImg] = React.useState(false);

    if(!product) return null;

    const {name, img, article, brand, link, img_thumbnail} = product;

    if(template === 'desktop') {
        return (<div className={styles.row}>
            <div className={styles.rowItem} onClick={() => document.location = `${link}`}>{brand}</div>
            <div className={styles.rowItem} onClick={() => document.location = `${link}`}>{article}</div>
            <div className={styles.rowItem}>
                <img height={48} style={{width: 'auto'}} src={img_thumbnail ? img_thumbnail : '/img/nopic.jpg'} alt={name} onClick={() => setOpenImg(true)}/>
                <Lightbox
                    open={openImg}
                    close={() => setOpenImg(false)}
                    slides={[
                        { src: img ? img : '/img/nopic.jpg' },
                    ]}
                />
            </div>
            <div className={styles.rowItem} onClick={() => document.location = `${link}`}>{name}</div>
            <div className={styles.rowItem}>
                <Button className={styles.rowItemBtn} id={`show-price-btn-${product.productId}`} type='regular' onClick={() => document.location = `${link}`}>
                    Узнать цены
                </Button>
            </div>
        </div>);
    }

    return (
        <li key={product.productId} className={styles.product}>
            <h4 className={styles.title} onClick={() => document.location = `${link}`}>{name}</h4>
            <div className={styles.outline} onClick={() => document.location = `${link}`}></div>
            <div className={styles.info}>
                <img className={styles.img} style={{width: 'auto'}} height={100} src={img_thumbnail ? img_thumbnail : '/img/nopic.jpg'} alt={name} onClick={() => setOpenImg(true)}/>
                <Lightbox
                    open={openImg}
                    close={() => setOpenImg(false)}
                    slides={[
                        { src: img ? img : '/img/nopic.jpg' },
                    ]}
                />
                <div className={styles.brand} onClick={() => document.location = `${link}`}>{brand}</div>
                <div className={styles.productId} onClick={() => document.location = `${link}`}>{article}</div>
                <Button className={styles.btn} type='regular' onClick={() => document.location = `${link}`}>Узнать цены</Button>
            </div>
        </li>
    )
}

export const SearchProductList: React.FC<Props> = ({
                                                       products,
                                                       productsLength,
                                                   }) => {
    const {isMobile, isDesktop} = useScreenDetector();


    return (<>
        {isDesktop && (
            <div className={styles.table}>
                <div className={styles.header}>
                    <div className={styles.headerItem}>Производитель</div>
                    <div className={styles.headerItem}>Артикул</div>
                    <div className={styles.headerItem}>Фото</div>
                    <div className={styles.headerItem}>Описание</div>
                    <div className={styles.headerItem}></div>
                </div>
                {products.map((product: Product, key: number) => {
                    if(key > productsLength) return null;
                        return <ProductRow key={product.productId} product={product} template="desktop" />
                    }
                )}
            </div>
        )}

        {isMobile && (
            <div className={styles.wrapper}>
                <ul className={styles.productList}>
                    {products.map((product, key) => {
                        if(key > productsLength) return null;
                            return <ProductRow key={product.productId} product={product} template="mobile" />
                        }
                    )}
                </ul>
            </div>
        )}
    </>);
};